import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight, Sparkles } from "lucide-react";
import { api } from "../lib/api";
import { IMAGES } from "../lib/constants";
import { PageHero, SectionHeading, fadeUp, CTABand } from "../components/common";

export default function Residential() {
  const [services, setServices] = useState([]);
  const [addons, setAddons] = useState([]);
  useEffect(() => {
    api.get("/settings/public").then((r) => { setServices(r.data.services || []); setAddons(r.data.addons || []); });
  }, []);

  return (
    <div data-testid="residential-page">
      <PageHero eyebrow="Residential Cleaning"
        title="A cleaner home, booked in minutes"
        subtitle="Recurring, deep, move-in/out, apartment, vacation rental, and one-time cleaning — all backed by a friendly, reliable local team."
        image={IMAGES.residentialInterior}>
        <Link to="/book" className="inline-flex items-center gap-2 bg-primary text-white hover:bg-primary-hover font-semibold px-7 py-3.5 rounded-md transition-colors" data-testid="hero-book-btn">
          Book a Residential Cleaning <ArrowRight size={18} />
        </Link>
      </PageHero>

      <section className="bg-white">
        <div className="ubm-container py-20">
          <SectionHeading eyebrow="Our cleaning services" title="Choose the clean that fits your life"
            subtitle="Every service is customized to your home's size and needs. Here's what's included with each." />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((s, i) => (
              <motion.div key={s.id} {...fadeUp} transition={{ delay: (i % 3) * 0.06 }}
                className="flex flex-col border border-gray-200 rounded-md p-6 hover:border-primary hover:shadow-md transition-all">
                <div className="flex items-center justify-between">
                  <h3 className="font-semibold text-charcoal-900 text-lg">{s.name}</h3>
                  <span className="text-primary font-bold font-display">${Number(s.base_price).toFixed(0)}+</span>
                </div>
                <p className="mt-2 text-sm text-charcoal-600 leading-relaxed">{s.description}</p>
                <ul className="mt-4 space-y-1.5 flex-1">
                  {(s.included || []).map((inc) => (
                    <li key={inc} className="flex items-start gap-2 text-sm text-charcoal-700">
                      <CheckCircle2 size={15} className="text-primary mt-0.5 shrink-0" /> {inc}
                    </li>
                  ))}
                </ul>
                <Link to="/book" className="mt-5 inline-flex items-center justify-center gap-2 bg-charcoal-900 text-white hover:bg-charcoal-800 font-semibold px-5 py-2.5 rounded-md transition-colors text-sm" data-testid={`book-${s.id}`}>
                  Book Now <ArrowRight size={15} />
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#f8f9fa]">
        <div className="ubm-container py-20">
          <SectionHeading center eyebrow="Make it yours" title="Popular add-on services"
            subtitle="Customize any booking with the extras your home needs — priced transparently at checkout." />
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 max-w-4xl mx-auto">
            {addons.map((a, i) => (
              <motion.div key={a.id} {...fadeUp} transition={{ delay: i * 0.03 }}
                className="flex items-center justify-between border border-gray-200 bg-white rounded-md px-4 py-3">
                <span className="text-sm font-medium text-charcoal-800 flex items-center gap-2"><Sparkles size={14} className="text-primary" />{a.name}</span>
                <span className="text-sm font-semibold text-primary">+${Number(a.price).toFixed(0)}</span>
              </motion.div>
            ))}
          </div>
          <div className="text-center mt-10">
            <Link to="/book" className="inline-flex items-center gap-2 bg-primary text-white hover:bg-primary-hover font-semibold px-8 py-4 rounded-md transition-colors" data-testid="residential-book-cta">
              Start Your Booking <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
